module.exports = __webpack_public_path__ + "static/cafe01-d015cf63ec0190279eee4db13e4d0fc4.jpg";